import { render, staticRenderFns } from "./BasicModule.vue?vue&type=template&id=01a122fe&"
import script from "./BasicModule.vue?vue&type=script&lang=js&"
export * from "./BasicModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports